
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection } from "../Shared/Shared.js";
import { union_type, class_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(FormState, NotificationToDelete) {
        super();
        this.FormState = FormState;
        this.NotificationToDelete = NotificationToDelete;
    }
}

export function State_$reflection() {
    return record_type("Dashboard.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["NotificationToDelete", option_type(string_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RequestDeleteNotification", "ConfirmDeleteNotification", "CancelDeleteNotification", "NotificationDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.Types.Msg", [], Msg, () => [[["Item", string_type]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

